import Axios from './axiosWrapper';
import axios from "axios";
import autobind from 'autobind-decorator';


class BaseApi {
    private axios: any;
    private axiosWithHeaders: any;

    constructor(hostType = 'default') {
        this.axios = Axios.create(hostType);
        this.axiosWithHeaders = Axios.create(hostType, true)
    }

    post(url: string, data = {}, headers = {}) {
        return this.req('post', url, data, headers)
    }

    upload(url: string, data = {}, auth = true) {
        const {REACT_APP_API_URL} = process.env;
        const token = localStorage.getItem('token');
        if (!token && auth) return null;
        return axios({
            method: 'post',
            url: `${REACT_APP_API_URL}${url}`,
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data',
                'authorization': auth ? `Bearer ${token?.replace('%20', ' ')}` : ''
            }
        })
    }

    delete(url: string, data = {}, withHeaders = false) {
        return this.req('delete', url, data, withHeaders)
    }

    put(url: string, data = {}, withHeaders = false) {
        return this.req('put', url, data, withHeaders)
    }

    get(url: string, data = {}, withHeaders = false) {
        return this.req('get', url, data, withHeaders)
    }

    async req(method: string, url: string, data = {}, headers = {}) {
        if (!method)
            throw new Error('Method is required');
        if (!url)
            throw new Error('URL is required');

        /*if (cancelToken) {
            Object.assign(data, {cancelToken: cancelToken.token});
        }*/

        const reqData = {};
        if (method === 'get') {
            Object.assign(reqData, {params: data});
        } else {
            Object.assign(reqData, {...data});
        }
        const resp = await this.axios[method](url, reqData, headers);
        return this.serializer(resp);
    }

    @autobind
    serializer(response: any) {
        if (response.status && response.status === 'error') {
            throw response
        }
        return response || false;
    }
}

export default BaseApi
